/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersForSeeMoreSkeleton.defs'
export { main as default } from './getSuggestedUsersForSeeMoreSkeleton.defs'
